import {
  ARCHIVED_TICKETS,
  CANCEL_TICKET,
  CANCEL_TICKET_FEE,
  CHANGE_TICKET_DOCUMENT_LANGUAGE,
  CHANGE_TICKET_LEGAL_STATUS,
  CLEAR_OWNERS_LIST_FOR_GS_AND_PZ_EDIT,
  CLEAR_TICKET_FOR_EDIT,
  CLEAR_TICKET_LIST,
  CLEAR_ZENDESK_TICKET,
  CLOSE_TICKET,
  COMMENT_TICKET,
  DELETE_TICKET,
  DONE_TICKET,
  GENERATE_DOCUMENTATION,
  GENERATE_REMINDER_PAYMENT_SLIP,
  GET_ALL_VIOLATIONS,
  GET_TICKET_FOR_EDIT,
  GET_ZENDESK_TICKET,
  MANUALLY_PAY,
  MODIFY_TICKET,
  OWNERS_GAS_STATION_ZONES_FOR_EDITING_TICKET,
  OWNERS_PARKING_ZONES_FOR_EDITING_TICKET,
  REFUND_TICKET,
  RESET_TICKET,
  TICKET_LIST_FAILED,
} from "../actions/types";

/** Whether the ticket list has had a response, so the grid can tell "no records" from "not loaded yet". */
export const listStatus = {
  PENDING: "pending",
  LOADED: "loaded",
  FAILED: "failed",
};

const initialState = {
  violations: [],
  zendeskTicket: {},
  last: false,
  numberOfElements: 0,
  empty: true,
  listStatus: listStatus.PENDING,
  ownersParkingZonesForEditingTicket: [],
  ownersGasStationZonesForEditingTicket: [],
  ticketForEdit: {},
};

const emptyList = {
  violations: initialState.violations,
  last: initialState.last,
  numberOfElements: initialState.numberOfElements,
  empty: initialState.empty,
};

const violationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_VIOLATIONS:
      return {
        ...state,
        violations: action.payload,
        last: action.last,
        numberOfElements: action.numberOfElements,
        empty: action.empty,
        listStatus: listStatus.LOADED,
      };
    case CLEAR_TICKET_LIST:
      return { ...state, ...emptyList, listStatus: listStatus.PENDING };
    case TICKET_LIST_FAILED:
      return { ...state, ...emptyList, listStatus: listStatus.FAILED };
    case DELETE_TICKET:
      return {
        ...state,
        violations: state.violations.filter((v) => v.id !== action.payload),
      };
    case CANCEL_TICKET:
      return {
        ...state,
        violations: state.violations.map((v) =>
          v.id !== action.payload.id ? v : action.payload
        ),
      };

      case CLOSE_TICKET:
        return {
          ...state,
          violations: state.violations.map((v) =>
            v.id !== action.payload.id ? v : action.payload
          ),
        };

    case CANCEL_TICKET_FEE:
      return {
        ...state,
        violations: state.violations.map((v) =>
          v.id !== action.payload.id ? v : action.payload
        ),
      };
    case DONE_TICKET:
      return {
        ...state,
        violations: state.violations.map((v) =>
          v.id !== action.payload.id ? v : action.payload
        ),
      };
    case GENERATE_DOCUMENTATION:
      return {
        ...state,
        violations: state.violations.map((v) =>
          v.number !== action.payload ? v : { ...v }
        ),
      };
    case GENERATE_REMINDER_PAYMENT_SLIP:
      return {
        ...state,
        violations: state.violations.map((v) =>
          v.number !== action.payload ? v : { ...v, legalStatus: "REMINDED" }
        ),
      };
    case MANUALLY_PAY:
      return {
        ...state,
        violations: state.violations.map((v) =>
          v.id !== action.payload.id ? v : action.payload
        ),
      };
    case MODIFY_TICKET:
      return {
        ...state,
        violations: state.violations.map((v) =>
          v.id !== action.payload.id ? v : action.payload
        ),
      };

    case CHANGE_TICKET_LEGAL_STATUS:
      return {
        ...state,
        violations: state.violations.map((v) =>
          v.id !== action.payload.id ? v : action.payload
        ),
      };

    case REFUND_TICKET:
      return {
        ...state,
        violations: state.violations.map((v) =>
          v.id !== action.payload.id ? v : action.payload
        ),
      };

    case RESET_TICKET:
        return {
          ...state,
          violations: state.violations.map((v) =>
            v.id !== action.payload.id ? v : action.payload
          ),
        };

    case CHANGE_TICKET_DOCUMENT_LANGUAGE:
      return {
        ...state,
        violations: state.violations.map((v) =>
            v.id !== action.payload.id ? v : action.payload
        ),
      };

    case COMMENT_TICKET:
      return {
        ...state,
        violations: state.violations.map((v) =>
          v.number == action.payload.ticketNumber
            ? { ...v, comment: action.payload.comment }
            : v
        ),
      };
    case GET_ZENDESK_TICKET:
      return {
        ...state,
        zendeskTicket: action.payload,
      };
    case CLEAR_ZENDESK_TICKET:
      return {
        ...state,
        zendeskTicket: {},
      };
    case ARCHIVED_TICKETS:
      return {
        ...state,
        violations: state.violations.filter((v) => v.number !== action.payload),
      };

    case OWNERS_PARKING_ZONES_FOR_EDITING_TICKET:
      return {
        ...state,
        ownersParkingZonesForEditingTicket: action.payload,
      };
    case OWNERS_GAS_STATION_ZONES_FOR_EDITING_TICKET:
      return {
        ...state,
        ownersGasStationZonesForEditingTicket: action.payload,
      };
    case CLEAR_OWNERS_LIST_FOR_GS_AND_PZ_EDIT:
      return {
        ...state,
        ownersGasStationZonesForEditingTicket: [],
        ownersParkingZonesForEditingTicket: [],
      };

    case GET_TICKET_FOR_EDIT:
      return {
        ...state,
        ticketForEdit: action.payload,
      };
    case CLEAR_TICKET_FOR_EDIT:
      return {
        ...state,
        ticketForEdit: {},
      };
    default:
      return state;
  }
};

export default violationsReducer;
